const colorTypeOptionsRanking = [
	'#003769',
	'#003769',
	'#003769',
	'#003769',
	'#003769',
	'#003769',
	'#003769',
	'#003769',
	'#003769',
	'#003769',
]

export default {
	name: 'GraficoFundacoesSaiRanking',
	props: {
		data: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		categorias: []
	},
	methods: {
		processCategories(data) {
			const dadosOrdenados = this.processDataValues(data)
			return dadosOrdenados.map((item) => item.x)
		},
		processDataValues(data) {
			return data
				.map((item) => {
					const valorCaptacao =
						typeof item.valor_captacao === 'string'
							? Number(item.valor_captacao)
							: item.valor_captacao
					return {
						...item,
						y: valorCaptacao,
						x: item.sigla || 'Desconhecido',
						total: valorCaptacao,
						fundacoes_vinculadas: item.fundos?.map((f) => f.nome),
					}
				})
				.sort((a, b) => a.y - b.y)
		},
	},

	watch: {
		data() {
			const novaSerie = this.processDataValues(this.data)
			const novasCategorias = this.processCategories(this.data)

			if (this.chartInstance) {
				this.chartInstance.updateOptions({
					xaxis: {
						categories: novasCategorias,
					},
				})
				this.chartInstance.updateSeries([
					{
						name: '',
						data: novaSerie,
					},
				])
			}
		},
	},

	data() {
		return {
			chartInstance: null,
			optionsFundacoesRanking: {
				series: [
					{
						name: '',
						data: this.processDataValues(this.data),
					},
				],
				chart: {
					type: 'bar',
					height: 350,
				},
				title: {
					text: 'Top/Bottom SAI (Ajustado)',
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '60%',
						dataLabels: {
							position: 'top',
							maxItems: 100,
							hideOverflowingLabels: false,
							orientation: 'horizontal',
						},
					},
				},
				colors: colorTypeOptionsRanking,
				dataLabels: {
					enabled: true,
					textAnchor: 'middle',
					distributed: false,
					offsetY: -20,
					style: {
						fontSize: '12px',
						fontWeight: 600,
						colors: ['#373D3F'],
					},
					formatter: function (val, opts) {
						const dataPoint =
							opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]
						const absoluteValue = Math.abs(dataPoint.total || val)

						return GLOBAL.FMoneyK(val || dataPoint.total)
					},
					dropShadow: {
						enabled: false,
					},
				},
				tooltip: {
					marker: { show: false },
					y: {
						formatter: function (val, opts) {
							const data =
								opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]
							const vinculadas = data.fundacoes_vinculadas?.length
								? `<br><span class="text-neutral-75">Fundos Vinculados:<br/> ${data.fundacoes_vinculadas.join(
										'<br/>'
								  )}</span>`
								: ''

							return `Fundação: <span class="text-neutral-75"> ${
								data.x
							} </span>
							 	<br><span class="text-neutral-75">Captação Ajustada: ${data.y.toLocaleString(
								'pt-BR',
								{
									style: 'currency',
									currency: 'BRL',
									maximumFractionDigits: 0,
								}
							)} 
							</span>${vinculadas}`
						},
					},
				},
				xaxis: {},
				yaxis: {
					labels: {
						formatter: function (val) {
							return val.toLocaleString('pt-BR', {
								style: 'currency',
								currency: 'BRL',
								maximumFractionDigits: 0,
							})
						},
					},
				},
			},
		}
	},
	mounted() {
		const el = document.querySelector('#chart_fundacoes_sai_ranking')
		if (!el) {
			console.error('Elemento #chart_fundacoes_sai_ranking não encontrado!')
			return
		}

		this.chartInstance = new ApexCharts(el, this.optionsFundacoesRanking)
		this.chartInstance.render()
	},
	beforeUnmount() {
		if (this.chartInstance) {
			this.chartInstance.destroy()
		}
	},
	template: `
        <div id="chart_fundacoes_sai_ranking" class="w-full"></div>
    `,
}
